exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "p[data-v-e89fe95e] {\n  margin-bottom: 1rem;\n}\n\np.heading[data-v-e89fe95e] {\n  font-weight: bold;\n  margin-bottom: 1rem;\n  margin-top: 1.5rem;\n}\n\np.heading.first[data-v-e89fe95e] {\n  margin-top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-e89fe95e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./source/components/ConsentStep.vue
// module id = 135
// module chunks = 0